(ns common.schema.entities.customer
  (:require [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/integer-field :customer/customer-number
                     "Customer number"
                     {:authorization            su/access-system-user
                      :editor                   :editor.type/none
                      :grid                     :editor.type/none
                      :default-field-visibility :not-in-use
                      :system-semantics         su/system-controlled-optional-field-semantics})))
